import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../../config/baseWithToken";

export const getAllDisputes = createAsyncThunk(
  "admin/orders/disputes",
  async (dispute, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.get(`/admin/orders/disputes?storeId=${dispute.storeId || ""}&page=${dispute.page}&size=${50}`);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateDispute = createAsyncThunk(
  "admin/orders/disputes/update",
  async (disputeInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/orders/disputes/${disputeInfo.disputeId}`,
        disputeInfo.updateDetails
      );
      dispatch(getAllDisputes({ page: 0, limit: 50 }));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const markAsComplete = createAsyncThunk(
  "admin/orders/disputes/markAsComplete",
  async (disputeInfo, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/orders/disputes/${disputeInfo.disputeId}/markAsComplete`,
        disputeInfo.updateDetails
      );
      dispatch(getAllDisputes({ page: 0, limit: 50 }));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);




export const deleteDispute = createAsyncThunk(
  "admin/orders/disputes/delete",
  async (disputeId, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.put(
        `/admin/orders/disputes/delete/${disputeId}`
      );
      dispatch(getAllDisputes({ page: 0, limit: 50 }));
      toast.success(data.message);
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
